import React          from 'react';
import SearchNotFound from './SearchNotFound';

export default function KirokuNotFound({ isResults, children, ComponentSearchNoFound = SearchNotFound   }) {
    return !isResults ? <ComponentSearchNoFound/> : children;
}

